export default __webpack_public_path__ + "static/seven-9e7289d239e8ba58ba7cf23ce4e13406.png";